/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'project-contributors-picker.done': 'Done',
  'project-contributors-picker.go-back-label': 'Go Back',
  'project-contributors-picker.header': 'Select members on project',
  'project-contributors-picker.your-teams-secondary-text': '{membersCount, plural, one {# member} other {# members}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    'Select from {membersCount, plural, one {# member} other {# members}}',
  'project-contributors-picker.your-teams-title': 'Your teams',
  'project-fields.common.generic-error.description': 'Please check your internet connection and try again.',
  'project-fields.common.generic-error.title': 'Something went wrong',
  'project-fields.link-item.delete-label': 'Delete',
  'project-fields.link-item.edit-label': 'Edit',
  'project-fields.project-contributes-to.add-goal-title': 'Add goal',
  'project-fields.project-contributes-to.empty-title': 'No goals',
  'project-fields.project-contributes-to.title': 'Contributes to',
  'project-fields.project-contributors.add-contributors-title': 'Add contributors',
  'project-fields.project-contributors.empty-title': 'No contributors',
  'project-fields.project-contributors.remove-contributor': 'Remove contributor',
  'project-fields.project-contributors.remove-contributor-error-message': "Contributor couldn't be removed",
  'project-fields.project-contributors.remove-team': 'Remove team',
  'project-fields.project-contributors.show-more': 'Show more',
  'project-fields.project-contributors.title': 'Contributors',
  'project-fields.project-contributors.view-profile': 'View profile',
  'project-fields.project-contributors.view-profile-team': 'View profile',
  'project-fields.project-focus-areas.title': 'Focus areas',
  'project-fields.project-followers.add-followers-title': 'Add followers',
  'project-fields.project-followers.empty-title': 'No followers',
  'project-fields.project-followers.title': 'Followers',
  'project-fields.project-jira-work-picker.create-work-item-button': 'Create work item',
  'project-fields.project-jira-work-picker.recent-items-empty-image-alt': 'Recent work items empty state illustration',
  'project-fields.project-jira-work-picker.recents-empty-description':
    'Your recently viewed work items will show up here as you get going.',
  'project-fields.project-jira-work-picker.recents-empty-title': 'Get started with Jira',
  'project-fields.project-jira-work-picker.search-placeholder': 'Search Jira or paste a link',
  'project-fields.project-jira-work-picker.title': 'Recent work items',
  'project-fields.project-link-picker.aria-label': 'Recently viewed links',
  'project-fields.project-link-picker.invalid-link-input.error': 'Please check your link is a valid URL.',
  'project-fields.project-link-picker.link-input.clear-label': 'Clear link',
  'project-fields.project-link-picker.link-input.placeholder': 'Paste link or search recently viewed',
  'project-fields.project-link-picker.text-input.clear-label': 'Clear text',
  'project-fields.project-link-picker.text-input.placeholder': 'Text to display (optional)',
  'project-fields.project-links.add-links-title': 'Add links',
  'project-fields.project-links.add-links-tooltip': 'Add links to docs, designs and more',
  'project-fields.project-links.delete-link-button': 'Delete link',
  'project-fields.project-links.edit-link-button': 'Edit link',
  'project-fields.project-links.empty-title': 'No links',
  'project-fields.project-links.title': 'Links',
  'project-fields.project-owner.title': 'Owner',
  'project-fields.project-start-date.add-start-date-title': 'Add start date',
  'project-fields.project-start-date.cancel-button': 'Save',
  'project-fields.project-start-date.creation-date': 'This project was created on {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Edit project start date',
  'project-fields.project-start-date.empty-title': 'No start date',
  'project-fields.project-start-date.enter-start-date-title': 'Enter start date',
  'project-fields.project-start-date.open-calendar-label': 'Open calendar',
  'project-fields.project-start-date.read-only': 'Only contributors with edit access can change the start date.',
  'project-fields.project-start-date.title': 'Start date',
  'project-fields.project-state.archived': 'Archived',
  'project-fields.project-state.at-risk': 'At risk',
  'project-fields.project-state.cancelled': 'Canceled',
  'project-fields.project-state.completed': 'Completed 🎉',
  'project-fields.project-state.off-track': 'Off track',
  'project-fields.project-state.on-track': 'On track',
  'project-fields.project-state.paused': 'Paused',
  'project-fields.project-state.pending': 'Pending',
  'project-fields.project-status-picker.project-status-picker-more-button': 'More statuses',
  'project-fields.project-status.title': 'Status',
  'project-fields.project-tags.add-tags-title': 'Add tags',
  'project-fields.project-tags.empty-title': 'No tags',
  'project-fields.project-tags.title': 'Tags',
  'project-fields.project-target-date.picker-placeholder': 'Pending',
  'project-fields.project-target-date.title': 'Target date',
  'project-fields.project-work-items.show-all-non-final': 'Show all',
  'project-fields.project-work-items.show-less-non-final': 'Show less',
  'project-fields.project-work-tracked-picker.cancel-button': 'Save',
  'project-fields.project-work-tracked-picker.fallback-description':
    "Add a link to where you're tracking the work for this project",
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Please enter a valid URL',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Search for Jira work items',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Search or add links to locations where you’re tracking work for this project.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Try re-entering the Jira work item key or URL or using different terms to search.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'We couldn’t find a match',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Recently viewed',
  'project-fields.project-work-tracked-picker.results-title': 'Results',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Search Jira or add a link',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Link this project with the selected Jira work item and automatically keep details in sync.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Note that everyone who can see this Jira work item will see your project details.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Sync with Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Cancel',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Connect',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Select the details you want to use for this work moving forward:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Sync this project with Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Label syncing',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Sync labels from Jira with tags on the project',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Project name',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Start date',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Target date',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Work tracking link',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    "Search for Jira work items or add links to locations where you're tracking work for this project.",
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Where is the work tracked?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Add Jira work items',
  'project-fields.project-work-tracked.empty-title': 'No Jira work items',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Linked with Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Sync now',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Synced with Jira',
  'project-fields.project-work-tracked.title': 'Work tracked',
  'project-fields.related-project-picker.add-button-label': 'Add',
  'project-fields.related-project-picker.cancel-button-label': 'Cancel',
  'project-fields.related-project-picker.depended-by-option-label': 'Project is depended on by',
  'project-fields.related-project-picker.depends-on-option-label': 'Project is dependent on',
  'project-fields.related-project-picker.empty-state-description': 'Find related projects to link to this project.',
  'project-fields.related-project-picker.empty-state-title': 'Search for Projects',
  'project-fields.related-project-picker.project-relationship-type-label': 'Select the project relationship type',
  'project-fields.related-project-picker.project-search-placeholder': 'Search projects',
  'project-fields.related-project-picker.related-option-label': 'Project is related to',
  'project-fields.related-project-picker.related-project-list-label': 'Related Projects',
  'project-fields.related-projects.add-related-title': 'Add related projects',
  'project-fields.related-projects.add-related-tooltip': 'Add dependent or related projects',
  'project-fields.related-projects.dependent-by-projects-heading': 'Dependent on by',
  'project-fields.related-projects.dependent-on-projects-heading': 'Dependent on',
  'project-fields.related-projects.empty-title': 'No related projects',
  'project-fields.related-projects.related-projects-heading': 'Related to',
  'project-fields.related-projects.title': 'Related',
  'project-fields.use-project-flags.generic-error-description': 'Something went wrong, try again in a few minutes.',
  'project-fields.use-project-flags.generic-error-title': 'Something went wrong',
  'project-fields.use-project-flags.project-links-add-failure-title': "Link couldn't be added",
  'project-fields.use-project-flags.project-links-delete-failure-title': "Link couldn't be removed",
  'project-fields.use-project-flags.project-links-edit-failure-title': "Link couldn't be edited",
  'project-fields.use-project-flags.project-owner-change-error-header': 'Could not change project owner',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    "We couldn't update the project's start date",
  'project-fields.use-project-flags.project-tags-add-failure-title': "Tag couldn't be added",
  'project-fields.use-project-flags.project-tags-create-failure-title': "Tag couldn't be created",
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'The tag name you entered is too long. Please enter a tag name with 255 characters or fewer.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Tag couldn’t be created',
  'project-fields.use-project-flags.project-tags-remove-failure-title': "Tag couldn't be removed",
  'project-fields.use-project-flags.project-team-remove-failure-description': 'Error removing team, please try again',
  'project-fields.use-project-flags.related-project-remove-failure-title': "Related project couldn't be removed",
};
